import React from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';
import SortingDropdown from '~/modules/ecommerceProducts/components/SortingDropdown';
import { mediaQueryMax } from '~/modules/core/utils/cssHelpers/cssMedia';
import { Row, Column } from '~/modules/coreUI/components/layouts/helpers/LinearLayout';
import PaginationTextInfo from '~/modules/coreUI/components/pagination/PaginationTextInfo';
import Separator from '~/modules/coreUI/components/layouts/helpers/Separator';
import Spacer from '~/modules/coreUI/components/layouts/helpers/Spacer';

import ChangeProductsView from './ChangeProductsView';
import ItemsListFilter from './ItemsListFilter';
import FilterDropdown from './FilterDropdown';

const SortAndChangeProductsView = ({
  changeView,
  showCardViewChangers,
  isVertical,
  showFilterDropdown,
}) => {
  const changeCardsView = (value) => {
    changeView(value);
  };
  return (
    <React.Fragment>
      <Media query={mediaQueryMax('tablet')}>
        {matches => (matches ? (
          <Row spaceBetweenJustified topAligned>
            <ItemsListFilter />
            <Spacer size={1} />
            <Column bottomAligned>
              <Row>
                {showCardViewChangers && (
                <React.Fragment>
                  <ChangeProductsView isVertical={isVertical} changeView={changeCardsView} />
                  <Separator vertical spacerSize={1} separatorLength="large" />
                </React.Fragment>
                )}
                <SortingDropdown />
              </Row>
              <Spacer size={1} />
              <PaginationTextInfo />
            </Column>
          </Row>
        ) : (
          <Row spaceBetweenJustified>
            <Row>
              {showFilterDropdown && (
              <React.Fragment>
                <FilterDropdown showFilterDropdown={showFilterDropdown} />
                <Spacer size={2.5} />
              </React.Fragment>
              )}
              <PaginationTextInfo />
            </Row>
            <Row>
              {showCardViewChangers && (
              <React.Fragment>
                <ChangeProductsView isVertical={isVertical} changeView={changeCardsView} />
                <Separator vertical spacerSize={2} separatorLength="large" />
              </React.Fragment>
              )}
              <SortingDropdown />
            </Row>
          </Row>
        ))
        }
      </Media>
      <Spacer size={1} />
    </React.Fragment>
  );
};

SortAndChangeProductsView.propTypes = {
  changeView: PropTypes.func.isRequired,
  showCardViewChangers: PropTypes.bool,
  showFilterDropdown: PropTypes.bool,
  isVertical: PropTypes.bool,
};
SortAndChangeProductsView.defaultProps = {
  showCardViewChangers: false,
  showFilterDropdown: false,
  isVertical: true,
};
export default SortAndChangeProductsView;
